import { useEffect, useState } from "react";
import { PortalLayout } from "@/components/layout/PortalLayout";
import { GlassCard } from "@/components/GlassCard";
import { SectorBadge } from "@/components/Badges";
import api from "@/lib/api";

export default function BridgeArchive() {
  const [deals, setDeals] = useState([]);
  useEffect(() => { api.get("/bridge/archive").then((r) => setDeals(r.data)); }, []);
  return (
    <PortalLayout title="Archive">
      <p className="text-sm text-muted-foreground mb-6">Deals that were declined or withdrawn.</p>
      <div className="grid gap-4 md:grid-cols-2">
        {deals.length === 0 && <GlassCard className="p-10 text-center text-sm text-muted-foreground">No archived deals.</GlassCard>}
        {deals.map((d) => (
          <GlassCard key={d.id} className="p-5 opacity-80">
            <SectorBadge sector={d.sector} />
            <h3 className="mt-3 pdg-serif text-lg text-foreground">{d.title}</h3>
            <div className="text-xs text-muted-foreground mt-1">{d.geography} &middot; {d.size_range}</div>
          </GlassCard>
        ))}
      </div>
    </PortalLayout>
  );
}
